<template>
    <div class="pt470" id="pt470" v-cloak>
        <div class="itemTitle">
            <breadcrumb :decriptPage="$t('pt470.labels.title')"></breadcrumb>
            <!-- タイトル -->
            <h2>{{$t("pt470.labels.title")}}</h2>
        </div>
        <div class="search">
            <div v-if="isDispMsg">
                <font class="errorMessage">{{$t('pt470.labels.errMsg')}}</font>
            </div>
            <p>
                <!-- 下記の条件を指定し検索が行えます。 -->
                {{$t("pt470.labels.info")}}
            </p>
            <div class="searchCondition">
                <div class="">
                    <table class="searchTable">
                        <tr>
                            <!-- カテゴリ -->
                            <th>
                                <span>{{$t('pt470.labels.categoryCd')}}</span>
                            </th>
                            <td>
                                <div class="">
                                    <select class="categoryCdSelect" id="categoryCd" v-model="pt470Init.reqModel.categoryCd">
                                        <option v-for="(item, index) in pt470Init.categoryList" 
                                            :key="index"
                                            :value="item.KEY">
                                        {{item.VALUE}}
                                        </option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <!-- 商品名-->
                            <th>
                                <span>{{$t('pt470.labels.priorFlag')}}</span>
                            </th>
                            <td>
                                <input v-model="pt470Init.reqModel.itemNmOnly" class="itemNmOnlyInput" type="text" maxlength="250" id="itemNmOnly" :placeholder="$t('pt470.labels.message')">
                            </td>
                        </tr>
                        <tr v-if="pt470Init.priceFlg == 1">
                            <!-- 価格帯 -->
                            <th>
                                <span>{{$t('pt470.labels.price')}}</span>
                            </th>
                            <td>
                                <div class="">
                                    <input-number v-model="pt470Init.reqModel.priceS" type="text" name="priceS" id="priceS" class="priceSInput num"  size="12"  :maxlength="9"/>{{$t('pt470.labels.yen')}}
                                    <!-- ～ -->
                                    <span>{{$t('common.labels.fromTo')}}</span>
                                    <input-number v-model="pt470Init.reqModel.priceE" type="text" name="priceE" id="priceE" class="priceEInput num"  size="12"  :maxlength="9"/>{{$t('pt470.labels.yen')}}
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="searchBtn">
                    <!-- 検索 -->
                    <button class="btnSubmit" @click="search()">{{$t('common.buttons.search')}}</button>
                </div>
            </div>
        </div>
    </div>        
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck.vue';
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";

export default {
    /*
    * Name of component
    */
    name: "PT470ProductSearchDetailsParts",
    /*
    * Declare props
    */
    props: {
        ptInitData: {
            type: Object,
            default: null,
        }
    },

    /*
    * Declare components
    */
    components: {
        axios,
        common,
        EventBus,
        Message,
        InputCheck,
        SiteConstants,
        InputNumber,
        Breadcrumb
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isDownload: false,
            isPagingDisplay:true,
            isDispMsg:false,
            pt470Init: {
                reqModel: {categoryCd:"",
                           itemNmOnly:"",
                           priceS:"",
                           priceE:"",
                           priorFlag:"",
                          },
                categoryList:[],
                priceFlg:0
            },
            isModalShow:false,
            msgConfirm:'',
            SiteConstants: SiteConstants,
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],
            site: ""
        }
    },
    /*
    * Initialize
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        if (_this.ptInitData){
            _this.pt470Init.priceFlg = _this.ptInitData.priceFlg;
            _this.pt470Init.categoryList = _this.ptInitData.categoryList;
            _this.pt470Init.productUrl = _this.ptInitData.productUrl;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT470 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt470Init.priceFlg = response.data.priceFlg;
                _this.pt470Init.categoryList = response.data.categoryList;
                _this.pt470Init.productUrl = _this.ptInitData.productUrl;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
    },
    /*
    * Methods
    */
    methods: {
        search: function() {
            var _this = this;
            var categoryCd = _this.pt470Init.reqModel.categoryCd != null ? _this.pt470Init.reqModel.categoryCd : '';
            var itemNmOnly = _this.pt470Init.reqModel.itemNmOnly;
            var priceS = _this.pt470Init.reqModel.priceS;
            var priceE = _this.pt470Init.reqModel.priceE;
            var priorFlag = _this.pt470Init.reqModel.priorFlag;

            if(categoryCd == '' && itemNmOnly == '' && (priceS == '' || priceS == null) && (priceE == '' || priceE == null) && priorFlag == ''){
                _this.isDispMsg = true;
            }else{
                const parameter = _this.generateLinkParams(2, _this.pt470Init.productUrl,{categoryCd: categoryCd, itemNmOnly: itemNmOnly, priceS: priceS, priceE: priceE, priorFlag: priorFlag}, {pageNo: 2});
                _this.$router.push(parameter);
                _this.$forceUpdate();
            }
        },
        // ルーターリンクパラメータ設定
        generateLinkParams(pageNo, customUrl, additionalQuery = {}, additionalParams = {}) {
            return common.routerLinkParams(pageNo, customUrl, additionalQuery, additionalParams);
        }
    }
}
</script>
